// Tenantra Inc. - Money owed by age: 0–30 / 31–60 / 61–90 / 90+ days, click a bucket to see who owes what
import { Card, fmtDate, money, plural } from './kit';

const TONE = { '0_30': ['bg-amber-300', 'text-amber-700'], '31_60': ['bg-orange-400', 'text-orange-700'], '61_90': ['bg-red-400', 'text-red-700'], '90_plus': ['bg-red-700', 'text-red-800'] };

export function AgingCard({ aging, onDrill }) {
  const { total, buckets } = aging;
  const open = (b) => onDrill({
    crumb: 'Owed by age', title: `${b.label} overdue`,
    rows: b.items.map((o, i) => ({ key: `${o.tenancy_id}-${i}`, tenant_id: o.tenant_id, primary: o.tenant, secondary: `${o.item} · due ${fmtDate(o.due_date)} · ${plural(o.days, 'day')}`, value: money(o.amount), amount: o.amount, tone: 'text-red-700' })),
  });
  return (
    <Card title="Owed by age" aside={total > 0 ? `${money(total)} total` : 'Nothing owed'} testId="aging-card">
      <div className="px-5">
        <div className="h-2 rounded-full bg-slate-100 overflow-hidden flex" data-testid="aging-bar">
          {buckets.map(b => b.amount > 0 && <div key={b.key} className={`${TONE[b.key][0]} h-full`} style={{ width: `${(b.amount / (total || 1)) * 100}%` }} />)}
        </div>
      </div>
      <div className="grid grid-cols-2 gap-px mt-3 pb-2">
        {buckets.map(b => (
          <button key={b.key} type="button" onClick={() => open(b)} className="text-left px-5 py-2.5 hover:bg-slate-50/80 transition-colors rounded-md" data-testid={`aging-bucket-${b.key}`}>
            <p className="text-xs text-slate-500 inline-flex items-center gap-1.5"><span className={`w-2 h-2 rounded-full ${TONE[b.key][0]}`} />{b.label}</p>
            <p className={`text-lg font-medium tabular-nums mt-0.5 ${b.amount > 0 ? TONE[b.key][1] : 'text-slate-300'}`}>{money(b.amount)}</p>
            <p className="text-[11px] text-slate-400">{plural(b.count, 'item')}</p>
          </button>
        ))}
      </div>
    </Card>
  );
}
